function selectedLanguage(state) {
	return state.languages.find(language => language.locale === state.locale);
}

function getAllAvailableSettings(state) {
	return state.allAvailableSettings;
}

export default { selectedLanguage, getAllAvailableSettings };